import { DeviceType } from "./Device";

export enum AlarmSeverity {
  CRITICAL, WARNING, INFO
}

interface DefaultSettingsData {
  enabled: boolean;
  supported: boolean;
}

export interface DefaultSettings {
  default: {
    home: DefaultSettingsData,
    away: DefaultSettingsData,
    sleep: DefaultSettingsData,
  };
  supported: boolean;
}

export interface DeliveryMediums {
  call: DefaultSettings;
  email: DefaultSettings;
  push: DefaultSettings;
  sms: DefaultSettings;
  userConfigurable: boolean;
}

export interface Alarm {
  id: number;
  deliveryMediums: DeliveryMediums;
  isInternal: boolean;
  active: boolean;
  description: string;
  displayName: string;
  isShutoff: boolean;
  name: string;
  severity: AlarmSeverity;
  deviceType: DeviceType;
  triggersAlarm?: number;
  triggeredBy?: number;
}

export interface AlarmLabel {
  displayName: string;
  name: string;
  ids: number[];
}

export function severityToString(severity: AlarmSeverity): string {
  switch(severity) {
    case AlarmSeverity.CRITICAL:
      return 'critical';
    case AlarmSeverity.WARNING:
      return 'warning';
    case AlarmSeverity.INFO:
      return 'info';
  }
}

export function stringToSeverity(severity: string): AlarmSeverity {
  switch(severity) {
    case 'critical':
      return AlarmSeverity.CRITICAL;
    case 'warning':
      return AlarmSeverity.WARNING;
    case 'info':
      return AlarmSeverity.INFO;
    default:
      return AlarmSeverity.INFO;
  }
}